import { actionTypes } from './actions';

const countInitialState = {
  count: 0,
  placeholderData: null,
}

export default function reducer(state = countInitialState, action) {
  // console.log(1121,action);
  switch (action.type) {
    case actionTypes.ADD:
      return Object.assign({}, state, {
        count: state.count + 1,
      })
    case actionTypes.MINUS:
      return Object.assign({}, state, {
        count: state.count - 1,
      })
    case actionTypes.LOAD_DATA_SUCCESS:
      return {
        ...state,
        ...{ placeholderData: action.data },
      }
    default:
      return state
  }
}
